export default __webpack_public_path__ + "static/media/simple-list-1.e5815076.png";